
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from 'swiper/modules';
import styles from './HeroSlider.module.css';
import { VariableImage } from "../";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

type Props = {
  images: [
    {
      title: string,
      format: {
        original: {
          uri: string
        }
      },
      id: number
    }
  ],
  carousel: object,
  themeFormat: {
    primary: string
  }
}

const HeroSlider = ({ images, carousel, themeFormat }: Props) => (
  <section className={styles.Container}>
    <Swiper
      pagination={
        { clickable: true }}
      modules={[Pagination, Autoplay]}
      className={styles.swiperContainer}
      style={{ backgroundColor: themeFormat?.primary }}
      loop={true}
      speed={1500}
      autoplay={{
        delay: 2000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      }}
    >
      {Array.isArray(carousel) && carousel.map((slide, index) => {
        const imageContent = images.find(x => x.id === slide);
        if (imageContent) {
          return (
            <SwiperSlide key={slide} className={styles.swiperSlide}>
              <VariableImage image={imageContent} origin='internal' lazy={index !== 0} priority={index === 0} />
            </SwiperSlide>
          )
        }
      })}
    </Swiper>
  </section>
);

export default HeroSlider;
